import { Injectable } from '@angular/core';
import { ModalService } from '../services';
export class ModalMockService extends ModalService {static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ModalMockService_tsickle_Closure_declarations() {
/** @type {?} */
ModalMockService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ModalMockService.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
